import React from 'react';
import Modal from '@common/modal';
import CloseButton from '@common/closeButton';
import { AiProfileType, EAiProfileType } from '@domain/constant/aiProfileType';
import classnames from 'classnames/bind';
import styles from './competencyModal.module.scss';

const cx = classnames.bind(styles);

const Item = (props: { type: EAiProfileType }) => {
  const { name, type: typeEnglish, def, str, weak, img } = AiProfileType[props.type];
  return (
    <li className={cx('item')}>
      <div className={cx('profileArea')}>
        <div className={cx('profileWrap')}>
          <span className={cx('imgWrap')}>
            <i className={cx('img')} style={{ backgroundImage: `url(/img/components/acca/test/result${img})` }} />
          </span>
          <em className={cx('name')}>{name}</em>
          <span className={cx('type')}>{typeEnglish}</span>
        </div>
      </div>

      <div className={cx('descArea')}>
        <div className={cx('descWrap')}>
          <p className={cx('def')}>{def}</p>

          <div className={cx('tagWrap')}>
            <span className={cx('tag')}>
              <span className={cx('point', 'str')}>강점</span>
              <span className={cx('text')}>
                {str.map((tag) => {
                  return '#' + tag + ' ';
                })}
              </span>
            </span>
            <span className={cx('tag')}>
              <span className={cx('point', 'weak')}>약점</span>
              <span className={cx('text')}>
                {weak.map((tag) => {
                  return '#' + tag + ' ';
                })}
              </span>
            </span>
          </div>
        </div>
      </div>
    </li>
  );
};

const List = () => {
  const list = Object.keys(AiProfileType).map((type, index) => {
    return <Item key={index} type={type as EAiProfileType} />;
  });

  return <ul className={cx('list')}>{list}</ul>;
};

interface CompetencyModal {
  visible: boolean;
  onClose: (e: React.MouseEvent<HTMLElement>) => void;
}

const CompetencyModal = ({ visible, onClose }: CompetencyModal) => {
  return (
    <Modal visible={visible} dimmed={true} onClickBg={onClose}>
      <div className={cx('wrap')}>
        <div className={cx('banner')}>
          <div className={cx('titleArea')}>
            <span className={cx('subTitle')}>나는 어떤 유형의 인재일까?</span>
            <em className={cx('title')}>12가지 역량 유형 모두보기</em>
          </div>
        </div>
        <div className={cx('contentsWrap')}>
          <div className={cx('contents')}>
            <List />
          </div>
        </div>
        <CloseButton className={cx('btnClose')} onClick={onClose} />
      </div>
    </Modal>
  );
};

export default CompetencyModal;
